<template>
  <div>
    <select v-model="workflow.name">
      <option
        v-for="workflowDefinition in workflowDefinitions"
        :key="workflowDefinition.name + '_' + workflowDefinition.version"
        :value="workflowDefinition.name"
      >
        {{ workflowDefinition.name }} - {{ workflowDefinition.version }}
      </option>
    </select>
    <JsonEditor v-model="workflow" />
    <button @click="startWorkflow(workflow)">Create</button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'WorkflowCreate',
  data() {
    return {
      workflow: {
        name: null
      }
    }
  },
  computed: mapState(['workflowDefinitions']),
  methods: mapActions(['getWorkflowDefinitions', 'startWorkflow']),
  created() {
    this.getWorkflowDefinitions()
  },
  components: {
    JsonEditor
  }
}
</script>
